import React, { useState, useEffect } from 'react';
import { Streamdown } from 'streamdown';
import "streamdown/styles.css";



// Import CSS & assets
import './Chat.css';



const MessageAssistant = ({ message }) => {


    return (
        <div className="app__chat_messageassistant_container">
            <Streamdown animated isAnimating={true}>{message?.content}</Streamdown>
        </div>
    );
};

export default MessageAssistant;